import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Flex from "./Flex";

interface ChildPageNavProps {
  parentRoute: string;
  childPageTitle?: string;
}

export default function ChildPageNav({
  parentRoute,
  childPageTitle,
}: ChildPageNavProps) {
  return (
    <Flex gapSize={4}>
      <>
        <Link to={parentRoute}>
          <ParentPage>전체</ParentPage>
        </Link>

        <Arrow className="material-icons">chevron_right</Arrow>

        <ChildPage>{childPageTitle ?? "상세 정보"}</ChildPage>
      </>
    </Flex>
  );
}

const ParentPage = styled.span`
  cursor: pointer;
  font-size: 13px;
  line-height: 19.5px;
  text-align: right;
  color: #858c97;
`;

const Arrow = styled.span`
  width: 18px;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #858c97;
`;

const ChildPage = styled.span`
  font-size: 13px;
  font-weight: bold;
  line-height: 19.5px;
  text-align: right;
  color: #505050;
`;
